import { createContext, useContext, FC, useState, ReactNode } from "react";

export type CommandBarContextType = {
  isFetching: boolean;
  setIsFetching: (isFetching: boolean) => void;
};

export const CommandBarContext = createContext<CommandBarContextType>({
  isFetching: false,
  setIsFetching: () => {},
});
CommandBarContext.displayName = "CommandBarContext";

export const useCommandBar = () => useContext(CommandBarContext);

interface Props {
  children: ReactNode;
}

export const CommandBarProvider: FC<Props> = ({ children }) => {
  const [isFetching, setIsFetching] = useState(false);
  return (
    <CommandBarContext.Provider value={{ isFetching, setIsFetching }}>
      {children}
    </CommandBarContext.Provider>
  );
};
